module.exports = __webpack_public_path__ + "assets/cheerup5.6ff62983.svg";